import { render, staticRenderFns } from "./gj-tag.vue?vue&type=template&id=1c2968b4&scoped=true&"
import script from "./gj-tag.vue?vue&type=script&lang=js&"
export * from "./gj-tag.vue?vue&type=script&lang=js&"
import style0 from "./gj-tag.vue?vue&type=style&index=0&id=1c2968b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2968b4",
  null
  
)

export default component.exports